import m1_examRegMenu from "@components/excuseMenu/m1_examRegMenu";
import m2_examRegMenu from "@components/excuseMenu/m2_examRegMenu";
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
    components: {
        'm2ExamRegMenu': m2_examRegMenu,
        "m2Sidebar": m2Sidebar,
        "examRegMenu": m1_examRegMenu,
    },
    data() {
        return {
            dialogVisible: false,
            dialogImageUrl: '',
            examRegInfo: {},
            tableData: [],
            imgList: [],
            fileList: [],
            tip: '',
            auditStatus: {},
            payState: {
                succeed: 2,
            },
            tableInfoData: [],
            tableVal: {},
            region_nameStatus:true,
        }
    },
    methods: {
        getTableImgUrl: function (proc_id) {
            return new Promise((resolve, reject) => {
                if (proc_id) {
                    this.$http
                        .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"), {
                            params: {
                                proc_id: proc_id
                            }
                        })
                        .then(data => {
                            if (data.body.code == resultCode.Success) {
                                let link = data.body.data[0].link;
                                resolve(link);
                            }
                        });
                }

            });
        },
        getFileUrl: function (proc_id) {
            return new Promise((resolve, reject) => {

                this.$http
                    .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"), {
                        params: {
                            proc_id: proc_id
                        }
                    })
                    .then(data => {
                        if (data.body.code == resultCode.Success) {
                            let file = [];
                            for (let item of data.body.data) {
                                file.push({
                                    file_id: item.file_guid,
                                    name: item.name,
                                })
                            }
                            resolve(file);
                        }
                    });
            });
        },
        async asyncInitialPic(itemS, val) {
            if (itemS.type == 6 || itemS.type == 5) {
                if (itemS.type == 6) {
                    val.forEach(async i => {
                        for (let tag in i) {
                            if (itemS.tag == tag) {
                                let t = i[tag];
                                let link = await this.getTableImgUrl(i[tag]);
                                i[tag] = {
                                    proc_id: t,
                                    link: link
                                }
                            }
                        }
                    })
                } else if (itemS.type == 5) {
                    val.forEach(async i => {
                        for (let tag in i) {
                            if (itemS.tag == tag) {
                                let t = i[tag];

                                let file = await this.getFileUrl(i[tag]);
                                i[tag] = {
                                    proc_id: t,
                                    file: file
                                }
                            }
                        }
                    })
                }

                return new Promise(resolve => {
                    resolve(val)
                })
            } else {
                return new Promise(resolve => {
                    resolve(val)
                })
            }

        },
        async getData() {
            this.examRegInfo = this.$store.state.examRegInfo.examRegInfo;
            this.auditStatus = auditStatus;

            this.examRegInfo.text_info_confs.forEach((item, index) => {
                if (item.type == 8) {
                    this.tableInfoData.push(item);
                    this.tableVal = item.value;
                    let results = item.sections.map(async (itemS, index) => {
                        return await this.asyncInitialPic(itemS, this.tableVal);

                    });
                }
            })

            let num = 0;
            this.examRegInfo.pic_info_confs.forEach((item, index) => {
                this.imgList.push({
                    url: null,
                    file_guid: null,
                    name: item.name
                });
                if (item.value) {
                    this.getImgUrl(item.value, (index - num), 'img');
                }
            });
            this.examRegInfo.file_info_confs.forEach((item, index) => {
                if (item.value) {
                    this.getImgUrl(item.value, index, 'file');
                }
            })
            this.examRegInfo.region_subject_selections.subjects.forEach((item) => {
                this.tableData.push({
                    subject_name: item.subject_name,
                    price: item.price.toFixed(2) + '元',
                    region_name: this.examRegInfo.region_subject_selections.region_name
                })
            });
        },
        modifyInfo: function () {
            let reg_info_operation = 2;
            this.$confirm('考生修改信息后，请务必在【确认信息】页面提交报考信息', '注意', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get(globalProvider.serviceUrl('ex_exm/g/eri/{reg_id}/{reg_info_operation}'), {
                    params: {
                        reg_id: this.examRegInfo.exam_registration_id,
                        reg_info_operation: reg_info_operation
                    }
                }).then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.$store.commit('setExamRegInfo', data.body.data);
                        this.$router.push({
                            name: 'excuseExam.baseCollection'
                        });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        if (data.body.message == 'EX_EMP_BLACK_01') {
                            this.$confirm(data.body.data, '提示', {
                                confirmButtonText: '确认',
                                type: "warning"
                            })
                        } else {
                            this.$alert(getErrorMessage(data.body.message));

                        }
                    }
                })
            }).catch(() => {
                return false
            });
        },
        payOrder: function () {
            this.$router.push({
                name: 'default.examReg.payOrder'
            });
        },
        getImgUrl: function (proc_id, id, type_id) {
            this.$http.get(globalProvider.serviceUrl('oss/_f/g/lk/dl/{proc_id}'), {
                    params: {
                        proc_id: proc_id
                    }
                })
                .then((data) => {
                    if (data.body.code == resultCode.Success) {
                        if (type_id === 'img') {
                            this.imgList[id].url = data.body.data[0].link;
                            this.imgList[id].file_guid = data.body.data[0].file_guid;
                        }
                        if (type_id === 'file') {
                            for (let item of data.body.data) {
                                this.fileList.push({
                                    file_id: item.file_guid,
                                    name: item.name,
                                })
                            }
                        }
                        if (type_id === 'cert_pic') {
                            this.cert_pic.url = data.body.data[0].link;
                            this.cert_pic.file_guid = data.body.data[0].file_guid;
                        }
                    }
                });
        },
        download: function (file_guid) {
            this.$http.get(globalProvider.serviceUrl('oss/_f/g/lk/dl/single/{file_guid}'), {
                    params: {
                        file_guid: file_guid
                    }
                })
                .then((data) => {
                    if (data.body.code == resultCode.Success) {
                        try {
                            var elemIF = document.createElement("iframe");
                            elemIF.src = data.body.data.link;
                            elemIF.style.display = "none";
                            document.body.appendChild(elemIF);
                        } catch (e) {
                            zzrw.alert("下载异常！");
                        }
                    }
                });
        },
        handlePictureCardPreview(file_guid) {
            this.$http.get(globalProvider.serviceUrl('oss/_f/g/lk/dl/single/{file_guid}'), {
                    params: {
                        file_guid: file_guid
                    }
                })
                .then((data) => {
                    if (data.body.code == resultCode.Success) {
                        this.dialogImageUrl = data.body.data.link;
                        this.dialogVisible = true;
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                });
        },
        //获取提交的报考信息
        getRegModel: function (reg_id) {
            let reg_info_operation = 1;
            this.$http.get(globalProvider.serviceUrl('ex_exm/g/eri/{reg_id}/{reg_info_operation}'), {
                    params: {
                        reg_id: reg_id,
                        reg_info_operation: reg_info_operation
                    }
                })
                .then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.$store.commit('setExamRegInfo', data.body.data);
                        this.tableData = [];
                        this.imgList = [];
                        this.fileList = [];
                        if(data.body.data.region_subject_selections.region_name){
                            this.region_nameStatus=true;
                        }else{
                            this.region_nameStatus=false;
                        }
                        this.getData();
                    } else if (data.body.code == resultCode.NotSuccess) {
                        if (data.body.message == 'EX_EMP_BLACK_01') {
                            this.$confirm(data.body.data, '提示', {
                                confirmButtonText: '确认',
                                type: "warning"
                            })
                        } else {
                            this.$alert(getErrorMessage(data.body.message));

                        }
                    }
                })
        },
        goRegList: function () {
            this.$router.push({
                name: 'default_myExcuse'
            });
        }
    },
    created: function () {
        this.examRegInfo = this.$store.state.examRegInfo.examRegInfo;
        this.$store.commit('setHeaderState', '6');
        this.getRegModel(this.examRegInfo.exam_registration_id);
        //            this.getTip();
    }
}